import React from 'react';
import Tooltip from './Tooltip';

const StatusTooltip = ({ 
  status, 
  errors = [], 
  warnings = [], 
  children, 
  position = 'top' 
}) => {
  const getTooltipContent = () => {
    if (status === 'healthy' || status === 'active') {
      return 'Healthy';
    }
    
    if (status === 'warning' && warnings.length > 0) {
      // Parse warning format: "COMPONENT|TYPE|MESSAGE"
      const firstWarning = warnings[0];
      if (typeof firstWarning === 'string' && firstWarning.includes('|')) {
        const [, , message] = firstWarning.split('|');
        return message || 'Warning detected';
      }
      return firstWarning.message || firstWarning.description || 'Warning detected';
    }
    
    if ((status === 'error' || status === 'critical') && errors.length > 0) {
      // Parse error format: "COMPONENT|TYPE|MESSAGE"
      const firstError = errors[0];
      if (typeof firstError === 'string' && firstError.includes('|')) {
        const [, , message] = firstError.split('|');
        return message || 'Error detected';
      }
      return firstError.message || firstError.description || 'Error detected';
    }
    
    // Fallback based on status
    switch (status) {
      case 'warning':
        return 'Warning detected';
      case 'error':
      case 'critical':
        return 'Error detected';
      case 'offline':
        return 'Device offline';
      case 'disabled':
        return 'Device disabled';
      default:
        return 'Unknown status';
    }
  };

  const getStatusClass = () => {
    if (status === 'healthy' || status === 'active') {
      return 'status-healthy';
    }
    if (status === 'warning') {
      return 'status-warning';
    }
    if (status === 'error' || status === 'critical') {
      return 'status-error';
    }
    return '';
  };

  return (
    <Tooltip
      content={getTooltipContent()}
      position={position}
      className={getStatusClass()}
      delay={300}
    >
      {children}
    </Tooltip>
  );
};

export default StatusTooltip;
